import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export const AngieR = () => (
	<StaticImage
		loading="eager"
		src="./AngieR2.png"
		alt="Ryan-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const ArnoC = () => (
	<StaticImage
		loading="eager"
		src="./ArnoC4.png"
		alt="David-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const BhavyaV = () => (
	<StaticImage
		loading="eager"
		src="./BhavyaV2.png"
		alt="Christopher-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const JiahL = () => (
	<StaticImage
		loading="eager"
		src="./JiahL3.png"
		alt="Marco-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const LydiaM = () => (
	<StaticImage
		loading="eager"
		src="./LydiaM2.png"
		alt="Stephen-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const MarcoT = () => (
	<StaticImage
		loading="eager"
		src="./MarcoT2.png"
		alt="Mika-img"
		style={{ width: "100%", height: "100%" }}
	/>
);

export const SimonK = () => (
	<StaticImage
		loading="eager"
		src="./SimonK3.png"
		alt="Ruth-img"
		style={{ width: "100%", height: "100%" }}
	/>
);
